import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";

import debounce from "lodash.debounce";

export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

export const useDebounce: typeof debounce = (callback, delay, options) => {
  const callbackRef = useRef(callback);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useMemo(() => {
    const func: Parameters<typeof debounce>[0] = (...args) => callbackRef.current?.(...args);
    return debounce(func, delay, options);
  }, [delay, options]);
};
